module.exports = __webpack_public_path__ + "static/media/bg16.52d0e140.jpg";